import React from "react";
import { Proposal } from "../../../core";
const publicUrl = window.location.origin;
const proposalTableShadow = `${publicUrl}/proposal-table-shadow.jpg`;
const logoIcon = `${publicUrl}/city-info-logo-pdf.png`;


const ProposalPreviewThankYou: React.FC<{ proposal: Proposal}> = (props)=> {

    return (<table className="table-outer-area thank-you-page" style={{
      // backgroundImage: `url(${require("../../../assets/images/proposal-table-shadow.png")})`,
      backgroundImage: `url(${proposalTableShadow})`,
      // backgroundImage: `url(${backgroundBgWithShadow})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "bottom",
      backgroundSize: "cover",
      marginTop: "15px",
      minHeight: "794px"
    }} width="100%" cellPadding="0" cellSpacing="0">
      <tbody>
        <tr>
          <td align="right">
            <img width={110} src={logoIcon} alt="property image" />
          </td>
        </tr>

        <tr>
          <td align="center" style={{
            fontSize: "18px",
            fontWeight: 400,
            color: "#5E5E5E"
          }}>
            <i>
              WE LOOK FORWARD TO GETTING <br />
              YOU TO YOUR DREAM OFFICE
            </i>
          </td>
        </tr>

        <tr>
          <td align="center" style={{
            fontSize: "46px",
            fontWeight: 500,
            color: "#011D77",
            paddingTop: 0
          }}>
            <b>THANK YOU</b>
          </td>
        </tr>

        <tr>
          <td align="center">
            <table width="65%" cellPadding="0" cellSpacing="0">
              <tbody>
                <tr>
                  <td height="6" style={{
                    backgroundColor: "#C39864",
                    padding: 0
                  }}></td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td height="4"></td>
        </tr>
        <tr>
          <td align="center">
            <table width="40%" cellPadding="0" cellSpacing="0">
              <tbody>
                <tr>
                  <td>
                    <div style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 40
                    }}>

                      {props.proposal?.createdBy && <div>
                        <strong style={{
                          fontSize: "16px",
                          color: "#5E5E5E",
                          fontWeight: 900,
                          lineHeight: "31px",
                          textAlign: "left"
                        }}>
                          {props.proposal?.createdBy?.name}
                        </strong>
                        <p style={{
                          fontSize: "16px",
                          color: "#5E5E5E",
                          fontWeight: 400,
                          margin: 0
                        }}>
                          {props.proposal?.createdBy?.phone}
                        </p>
                        <p style={{
                          fontSize: "16px",
                          color: "#5E5E5E",
                          fontWeight: 400,
                          margin: 0
                        }}>
                          {props.proposal?.createdBy?.email}
                        </p>

                      </div>}


                      {props.proposal?.approvedBy && props.proposal?.approvedBy?._id !== props.proposal?.createdBy?._id && <div>
                        <strong style={{
                          fontSize: "16px",
                          color: "#5E5E5E",
                          fontWeight: 900,
                          lineHeight: "31px"
                        }}>
                          {props.proposal?.approvedBy?.name}
                        </strong>
                        <p style={{
                          fontSize: "16px",
                          color: "#5E5E5E",
                          fontWeight: 400,
                          margin: 0
                        }}>
                          {props.proposal?.approvedBy?.phone}
                        </p>
                        <p style={{
                          fontSize: "16px",
                          color: "#5E5E5E",
                          fontWeight: 400,
                          margin: 0
                        }}>
                          {props.proposal?.approvedBy?.email}
                        </p>
                      </div>}

                    </div>
                  </td>

                </tr>
              </tbody>
            </table>
          </td>
        </tr>

        <tr>
          <td height="20"></td>
        </tr>
        <tr>
          <td valign="top" align="center">
            <table width="90%" cellPadding="0" cellSpacing="0">
              <tbody>
                <tr>
                  <td>
                    <strong style={{
                      fontSize: "14px",
                      color: "#929292",
                      fontWeight: 900,
                      lineHeight: "23px"
                    }}>
                      BENGALURU
                    </strong>
                    <p style={{
                      fontSize: "13px",
                      color: "#929292",
                      fontWeight: 400,
                      margin: 0,
                      lineHeight: "21px"
                    }}>
                      Ground Floor, Aurbis Concord <br /> No.10, Richmond
                      Road, Bengaluru 560 025 <br /> Phone: +91 80 4411 0000
                    </p>
                  </td>

                  <td>
                    <strong style={{
                      fontSize: "14px",
                      color: "#929292",
                      fontWeight: 900,
                      lineHeight: "23px"
                    }}>
                      CHENNAI
                    </strong>
                    <p style={{
                      fontSize: "13px",
                      color: "#929292",
                      fontWeight: 400,
                      margin: 0,
                      lineHeight: "21px"
                    }}>
                      Ground Floor, Aurbis Concord <br /> No.10, Richmond
                      Road, Bengaluru 560 025 <br /> Phone: +91 80 4411 0000
                    </p>
                  </td>

                  <td>
                    <strong style={{
                      fontSize: "14px",
                      color: "#929292",
                      fontWeight: 900,
                      lineHeight: "23px"
                    }}>
                      DELHI NCR
                    </strong>
                    <p style={{
                      fontSize: "13px",
                      color: "#929292",
                      fontWeight: 400,
                      margin: 0,
                      lineHeight: "21px"
                    }}>
                      Ground Floor, Aurbis Concord <br /> No.10, Richmond
                      Road, Bengaluru 560 025 <br /> Phone: +91 80 4411 0000
                    </p>
                  </td>

                  <td>
                    <strong style={{
                      fontSize: "14px",
                      color: "#929292",
                      fontWeight: 900,
                      lineHeight: "23px"
                    }}>
                      KOCHI
                    </strong>
                    <p style={{
                      fontSize: "13px",
                      color: "#929292",
                      fontWeight: 400,
                      margin: 0,
                      lineHeight: "21px"
                    }}>
                      Ground Floor, Aurbis Concord <br /> No.10, Richmond
                      Road, Bengaluru 560 025 <br /> Phone: +91 80 4411 0000
                    </p>
                  </td>
                </tr>
                <tr>
                  <td height="15"></td>
                </tr>

                <tr>
                  <td>
                    <strong style={{
                      fontSize: "14px",
                      color: "#929292",
                      fontWeight: 900,
                      lineHeight: "23px"
                    }}>
                      MUMBAI
                    </strong>
                    <p style={{
                      fontSize: "13px",
                      color: "#929292",
                      fontWeight: 400,
                      margin: 0,
                      lineHeight: "21px"
                    }}>
                      Ground Floor, Aurbis Concord <br /> No.10, Richmond
                      Road, Bengaluru 560 025 <br /> Phone: +91 80 4411 0000
                    </p>
                  </td>

                  <td>
                    <strong style={{
                      fontSize: "14px",
                      color: "#929292",
                      fontWeight: 900,
                      lineHeight: "23px"
                    }}>
                      HYDERABAD
                    </strong>
                    <p style={{
                      fontSize: "13px",
                      color: "#929292",
                      fontWeight: 400,
                      margin: 0,
                      lineHeight: "21px"
                    }}>
                      Ground Floor, Aurbis Concord <br /> No.10, Richmond
                      Road, Bengaluru 560 025 <br /> Phone: +91 80 4411 0000
                    </p>
                  </td>

                  <td>
                    <strong style={{
                      fontSize: "14px",
                      color: "#929292",
                      fontWeight: 900,
                      lineHeight: "23px"
                    }}>
                      PUNE
                    </strong>
                    <p style={{
                      fontSize: "13px",
                      color: "#929292",
                      fontWeight: 400,
                      margin: 0,
                      lineHeight: "21px"
                    }}>
                      Ground Floor, Aurbis Concord <br /> No.10, Richmond
                      Road, Bengaluru 560 025 <br /> Phone: +91 80 4411 0000
                    </p>
                  </td>

                  <td>
                    <strong style={{
                      fontSize: "14px",
                      color: "#929292",
                      fontWeight: 900,
                      lineHeight: "23px"
                    }}>
                      COIMBATORE
                    </strong>
                    <p style={{
                      fontSize: "13px",
                      color: "#929292",
                      fontWeight: 400,
                      margin: 0,
                      lineHeight: "21px"
                    }}>
                      Ground Floor, Aurbis Concord <br /> No.10, Richmond
                      Road, Bengaluru 560 025 <br /> Phone: +91 80 4411 0000
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4} height="50"></td>
                </tr>

                <tr>
                  <td colSpan={4} align="center" style={{
                    fontSize: "13px",
                    color: "#011D77"
                  }}>
                    <i>
                      <a href="https://cityinfoservices.com/" target="_blank" style={{
                        color: "#011D77",
                        paddingBottom: '5px',
                        borderBottom: '1px solid #011D77',
                        textDecoration: "none"
                      }}>www.cityinfoservices.com</a>{" "}
                      <u style={{
                        fontStyle: "normal"
                      }}>|</u>{" "}
                      <a href="https://properties.cityinfoservices.com" style={{
                        color: "#011D77",
                        paddingBottom: '5px',
                        borderBottom: '1px solid #011D77',
                        textDecoration: "none"
                      }} target="_blank">https://properties.cityinfoservices.com</a>
                    </i>
                  </td>
                </tr>
                <tr>
                  <td height="14" colSpan={4}></td>
                </tr>

                <tr>
                  <td colSpan={4}>
                    <p style={{
                      fontSize: "12px",
                      color: "#5E5E5E",
                      textAlign: "center",
                      margin: 0,
                      lineHeight: '17px'
                    }}>
                      <i>
                        This Document is intended only for the use of the individual or entity to which it is addressed and may contain information that is non-public, proprietary, privileged, confidential, and exempt from disclosure under applicable law or may constitute as
                        attorney work product. Options Offered in this proposal is Under discussion with multiple clients – Area subject to availability at the time of space take-up & Quoted Commercial Terms are subject to change without notice Information gathered from public sources, inaccuracies are disclaimed and information is subject to change without notice.
                      </i>
                    </p>
                  </td>
                </tr>
                {
                  /* 
                  <tr>
                   <td height="15" colSpan={4}></td>
                  </tr>
                   <tr>
                   <td colSpan={4}>
                     <p
                       style={{
                         fontSize: "11px",
                         color: "#5E5E5E",
                         textAlign: "center",
                       }}
                     >
                       <i>All copyrights acknowledged.</i>
                     </p>
                   </td>
                  </tr> */
                }
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>);
  }


  export default ProposalPreviewThankYou;